import { BaseComponent } from 'components/BaseComponent';
import React, { Fragment } from 'react';
import { enPaymentStatus } from 'enums/enPaymentStatus';
import { SvgIcon } from 'components/SvgIcon';
import Translate from 'components/Translate';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = require('./paymentButtonMessage.css');

export interface IProps {
  message: string;
  status: enPaymentStatus;
}

export default class PaymentButtonMessage extends BaseComponent<{}, IProps> {

  constructor(props: any) {
    super(props);
  }

  idleMessage = () => (
    <Fragment>
      <SvgIcon name='security' />
      <Translate term={this.props.message} />
    </Fragment>
  )

  successMessage = () => (
    <Fragment>
      <SvgIcon name='checkIcon' />
    </Fragment>
  )

  errorMessage = () => (
    <Fragment>
      <Translate term='Não foi possível concluir o pagamento' className='errorMessage' />
    </Fragment>
  )

  progressMessage = () => (
    <Fragment>
      <CircularProgress size={25} style={{ color: '#fff' }} className='theme-button-color' />
      <Translate term='Já é quase seu!' className='progressMessage' />
    </Fragment>
  )

  render() {
    const { status } = this.props;

    return (
      <span className={styles.component}>
        {(status === enPaymentStatus.IDLE) ? <this.idleMessage /> : null}
        {(status === enPaymentStatus.PROGRESS) ? <this.progressMessage /> : null}
        {(status === enPaymentStatus.SUCCESS) ? <this.successMessage /> : null}
        {(status === enPaymentStatus.ERROR) ? <this.errorMessage /> : null}
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/PaymentButton/PaymentButtonMessage/index.tsx